export function passwordStrengthError(password: string): string | undefined {
  if (password.length < 12 || password.length > 128) {
    return "密码长度必须为 12 至 128 位";
  }

  const characterClassCount = [
    /\p{Ll}/u.test(password),
    /\p{Lu}/u.test(password),
    /\p{Nd}/u.test(password),
    /[^\p{L}\p{N}]/u.test(password),
  ].filter(Boolean).length;

  return characterClassCount < 3 ? "密码必须包含大小写字母、数字和符号中的至少三类" : undefined;
}
